import { useTranslation } from "react-i18next";
import { SelectStyled } from "../../../../style/Input";
import { useMemo } from "react";
import { SelectPair } from "../../../../types/common.types";

interface IBranchesSelectProps {
  value: string | undefined;
  required?: boolean | undefined;
  branchesCodesToExclude?: string[];
  onChange: (val: string) => void;
}

const BranchesSelect = ({
  value,
  required,
  branchesCodesToExclude,
  onChange,
}: IBranchesSelectProps) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    const result: SelectPair[] = [];

    const _branchesCodesToExclude = branchesCodesToExclude ?? [];

    Array.from(Array(15).keys(), (key) => key + 1).forEach((code) => {
      if (!_branchesCodesToExclude.includes(code.toString())) {
        result.push({
          value: code.toString(),
          label: t(`policy-branch-${code}`),
        });
      }
    });

    return result.sort((a, b) => (a!.label < b!.label ? -1 : 1));
  }, [branchesCodesToExclude]);

  return (
    <SelectStyled
      label={t("LABELS.branch")}
      required={required}
      value={value}
      options={options}
      onChange={onChange}
    />
  );
};

export default BranchesSelect;
